// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import ReportFiltersController from "./report_filters_controller"
application.register("report-filters", ReportFiltersController)

import TableSortController from "./table_sort_controller"
application.register("table-sort", TableSortController)

import BarcodeController from "./barcode_controller"
application.register("barcode", BarcodeController)
